// extracted by mini-css-extract-plugin
module.exports = {"img":"styles-module__img___234yq"};